import ResponsiveFooter from "../responsivefooter/ResponsiveFooter.vue"

export default {
  name: 'content-blocker',
  components: {    responsivefooter: ResponsiveFooter},
  props: [],
  data () {
    return {

    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {

  }
}


